export const getExtension = (fileName = ''): string => {
    const lastDot = fileName.lastIndexOf('.');
    return lastDot !== -1 ? fileName.slice(lastDot) : '';
};

export const maskOriginalFilename = (fileName = ''): string => {
    const extension = getExtension(fileName);
    return extension ? `*******${extension}` : '*******';
};

export const buildAnonymizedOriginalCvLabel = (fileName = '', index = 0): string => {
    const extension = getExtension(fileName);
    return extension ? `Original_CV_${index + 1}${extension}` : `Original_CV_${index + 1}`;
};
